export class MockCapacitationService {
  getCollaboratorCapacitations = jasmine.createSpy('getCollaboratorCapacitations');
  getCapacitationsByConcessionSlug = jasmine.createSpy('getCapacitationsByConcessionSlug');
  patchCapacitationBlocked = jasmine.createSpy('patchCapacitationBlocked');
  patchCapacitationExempted = jasmine.createSpy('patchCapacitationExempted');
  getCollaboratorCapacitationPrograms = jasmine.createSpy('getCollaboratorCapacitationPrograms');
}
